import { SectionEyebrow } from "../landing/SectionEyebrow";

const ROWS = [
  ["Debt Service Coverage Ratio (DSCR)", "Greater than or equal to 1.35x",
   "Confirms the member or business can service the loan from actual income or cash flow — not just savings-multiplier eligibility."],
  ["Verifiable transaction history", "3–6 months of statements", "Confirms income and expenses are real and verifiable."],
  ["Income and revenue consistency", "No unexplained volatility", "Screens risk that guarantor vetting alone cannot detect."],
  ["Documentation completeness", "Minimum scorable submission", "Ensures the SACCO receives a complete file."],
  ["Critical hard-check failures", "Zero", "Screens out disqualifying compliance issues."],
];

export const SaccoFramework = () => (
  <section className="bg-[#0B2A28] text-white" data-testid="sacco-framework">
    <div className="mx-auto max-w-6xl px-5 py-20 sm:py-24">
      <SectionEyebrow tone="dark" testid="sacco-framework-eyebrow">Qualification Framework</SectionEyebrow>
      <p className="mt-6 max-w-3xl text-base leading-relaxed text-[#B9D9D6] md:text-lg" data-testid="sacco-framework-subheading">
        A repayment-capacity layer added on top of your existing security model — not a replacement for guarantors or collateral.
      </p>
      <div className="mt-10 overflow-x-auto rounded-2xl border border-white/10 bg-white/[0.04] backdrop-blur">
        <table className="w-full min-w-[640px] text-left text-sm" data-testid="sacco-framework-table">
          <thead>
            <tr className="border-b border-white/10 text-[11px] font-extrabold uppercase tracking-[0.2em] text-[#7BD3CE]">
              <th className="px-6 py-4">Check</th>
              <th className="px-6 py-4">Illustrative Threshold</th>
              <th className="px-6 py-4">Purpose</th>
            </tr>
          </thead>
          <tbody>
            {ROWS.map(([check, threshold, purpose], i) => (
              <tr key={check} className="border-b border-white/10 last:border-0 hover:bg-white/[0.04]" data-testid={`sacco-framework-row-${i + 1}`}>
                <td className="px-6 py-5 font-bold text-white">{check}</td>
                <td className="px-6 py-5">
                  <span className="inline-block rounded-full border border-[#E3B84C]/50 bg-[#E3B84C]/10 px-3 py-1 text-xs font-bold text-[#E3B84C]">{threshold}</span>
                </td>
                <td className="px-6 py-5 leading-relaxed text-[#B9D9D6]">{purpose}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="mt-6 text-sm text-[#B9D9D6]" data-testid="sacco-framework-note">
        <span className="font-bold text-white">Note:</span> The threshold is a joint decision — the SACCO validates it against its own approval and default data before launch.
      </p>
    </div>
  </section>
);
